import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { areaService } from '../services/areaService';
import { Area } from '../types/area';

export const useAreas = () => {
  const queryClient = useQueryClient();

  const { data: areas = [], isLoading, error } = useQuery({
    queryKey: ['areas'],
    queryFn: areaService.getAreas,
  });

  const createArea = useMutation({
    mutationFn: areaService.createArea,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['areas'] });
    },
  });

  const updateArea = useMutation({
    mutationFn: ({ code, data }: { code: string; data: Partial<Area> }) =>
      areaService.updateArea(code, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['areas'] });
    },
  });

  const deleteArea = useMutation({
    mutationFn: areaService.deleteArea,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['areas'] });
    },
  });

  return {
    areas,
    isLoading,
    error,
    createArea,
    updateArea,
    deleteArea,
  };
}; 